import { createClient } from '@supabase/supabase-js';

import type { SupabaseClient } from '@supabase/supabase-js';

import { SUPABASE_ANON_KEY, SUPABASE_URL } from '@/constants/env';

import type { Database } from './database.types';

import { admittedSessionStorage } from './sessionStorage';

type TSupabaseClient = SupabaseClient<Database>;

let client: TSupabaseClient | null = null;

const resolveSupabaseClient = (): TSupabaseClient => {
  if (!client) {
    client = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        storage: admittedSessionStorage,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
      },
    });
  }

  return client;
};

const readAccessToken = async (): Promise<string | null> => {
  const { data } = await resolveSupabaseClient().auth.getSession();

  return data.session?.access_token ?? null;
};

export type {
  TSupabaseClient,
};
export {
  readAccessToken,
  resolveSupabaseClient,
};
